export { ContentSectionVariantSix } from "./content-section-variant-six";
